import {
  BBOrCustomSupplier,
  isCustomSupplier,
} from '@bridebook/web/lib/supplier/hooks/query/use-supplier';
import compact from 'lodash/compact';

export const getSupplierAddressText = (supplier: BBOrCustomSupplier) => {
  // for some reason, custom suppliers now push all the elements of address into street
  if (isCustomSupplier(supplier)) return supplier.address?.street?.join(', ') ?? null;

  const translationValues = supplier?.address
    ? {
        ...supplier.address,
        street: supplier.address.street?.[0] ?? '',
      }
    : undefined;

  return translationValues
    ? compact([
        translationValues.street,
        translationValues.city,
        translationValues.postalCode,
      ]).join(', ')
    : null;
};
